import { useUserId } from 'modules/app/hooks/useUserId';
import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

export type UpdateUserMissingInformationPayload = Partial<{
  display_gender: string;
  first_name: string;
  last_name: string;
  lang: string;
  gender: string;
  birth_date?: string;
  birth_location_city?: string;
  birth_location_country_code?: string;
  email?: string;
}>;

export type UpdateUserMissingInformationErrorCode =
  | 'email_update_not_allowed'
  | 'invalid_name'
  | 'not_account_owner'
  | 'sso_or_saml_enabled'
  | 'sfs_kyc_review_not_started'
  | 'sfs_kyc_review_already_completed';

export type UpdateUserMissingInformationError = {
  errors: Array<{ code: UpdateUserMissingInformationErrorCode }>;
};

type Props = {
  onError?: () => void;
};

export const useUpdateUserMissingInformationMutation = ({
  onError,
}: Props = {}): MutationState<
  UpdateUserMissingInformationPayload,
  object,
  UpdateUserMissingInformationError
> => {
  const userId = useUserId();

  return useMutation<
    UpdateUserMissingInformationPayload,
    object,
    object,
    UpdateUserMissingInformationError
  >({
    request: {
      type: 'rest',
      method: 'put',
      target: 'companyAPI',
      endpoint: `/users/${userId}/missing-information`,
    },
    reshapeData(data) {
      return data;
    },
    options: {
      ...(onError ? { onError } : {}),
    },
  });
};
